import { Component } from '@angular/core';

@Component({
    selector: 'app-shared-modal-footer',
    templateUrl: './shared-modal-footer.component.html',
    styleUrls: ['./shared-modal-footer.component.scss'],
    standalone: false
})
export class SharedModalFooterComponent {

}
